import React, { useCallback, useEffect, useState } from 'react';
import { Content, Button, ContactsListContainer } from './styles';
import Modal from '../index';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationCard from '../../Confirmation/ConfirmationCards';
import {
  setEmailConfirmado,
  setTelefoneConfirmado,
  setUserConfirmedData,
  setEnderecoConfirmado,
} from '../../../store/auth/actions';
import InputComponent from '../../Input';
import {
  formatTelephone,
  formatTelephoneReverse,
} from '../../../services/utils/formatTELandCEP';
import { getTelsAndEmails } from '../../../store/contacts/actions';
import api from '../../../services/api';

interface IConfirmData {
  handlerClose: () => void;
  sendData: (code: string) => void;
  setDataModal: (state: boolean) => void;
  code: string;
}

const ConfirmData = ({
  handlerClose,
  sendData,
  setDataModal,
  code,
}: IConfirmData) => {
  const { cpf, userConfirmed, contactsLoading, contactsList } = useSelector(
    (state: ApplicationState) => ({
      cpf: state.auth.cpf,
      userConfirmed: state.auth.userConfirmedData,
      contactsList: state.contacts.contactsLists,
      contactsLoading: state.contacts.contactsLoading,
    })
  );
  const [userContacts, setUserContacts] = useState<UserContact[]>([]);
  const [emailCode, setEmailCode] = useState<string | number | null>(null);
  const [telCode, setTelCode] = useState<string | number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [inptEmail, setInptEmail] = useState<string>('');
  const [inptTelephone, setInptTelephone] = useState<string>('');
  const [emailError, setEmailError] = useState<boolean>(false);
  const [telError, setTelError] = useState<boolean>(false);
  const [newContact, setNewContact] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [cep, setCep] = useState('');
  const [number, setNumber] = useState('');
  const [complement, setComplement] = useState('');
  const [neighborhood, setNeighborhood] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');

  const handleAddressSubmit = async () => {
    setLoading(true);

    try {
      dispatch(
        setEnderecoConfirmado.request({
          data: {
            cep,
            number,
            complement,
            neighborhood,
            city,
            state,
          },
        })
      );

      setDataModal(false);
    } catch (err) {
      console.error('Erro ao cadastrar endereço:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userConfirmed?.email && code === 'Email') {
      sendData(code);
      setDataModal(false);
      setLoading(false);
    }
    if (userConfirmed?.telephone && (code === 'SMS' || code === 'Whatsapp')) {
      sendData(code);
      setDataModal(false);
      setLoading(false);
    }
  }, [code, sendData, setDataModal, userConfirmed]);

  useEffect(() => {
    dispatch(getTelsAndEmails.request({ cpf }));
  }, [cpf, dispatch]);

  useEffect(() => {
    const contactsData = () => {
      if (contactsList && contactsList.length) {
        let ordenedData: GQL.IEmail[] | GQL.ITelephone[] = [];
        if (code === 'Email') {
          ordenedData = (contactsList[1] as GQL.IEmail[]).sort((cur, old) =>
            (cur.cod_email as number) > (old.cod_email as number) ? 1 : -1
          );
          setUserContacts(ordenedData);
        } else {
          ordenedData = (contactsList[0] as GQL.ITelephone[]).sort((cur, old) =>
            (cur.cod_tel as number) > (old.cod_tel as number) ? 1 : -1
          );
          setUserContacts(ordenedData);
        }
      }
    };
    contactsData();
  }, [code, contactsList]);

  useEffect(() => {
    if (!newContact && code === 'Email') {
      setInptEmail('');
    }
    if (!newContact && (code === 'SMS' || code === 'Whatsapp')) {
      setInptTelephone('');
    }
  }, [code, newContact]);

  const handleConfirm = () => {
    if (emailCode && !newContact) {
      setLoading(true);
      const exactEmail = userContacts[(emailCode as number) - 1];

      dispatch(
        setEmailConfirmado.request({
          data: {
            contactId: (exactEmail as GQL.IEmail).cod_email as number | null,
            databaseId: (exactEmail as GQL.IEmail).databaseId,
          },
        })
      );
    }

    if (telCode && !newContact) {
      setLoading(true);
      const exactTel = userContacts[(telCode as number) - 1];

      dispatch(
        setTelefoneConfirmado.request({
          data: {
            contactId: (exactTel as GQL.ITelephone).cod_tel as number | null,
            databaseId: (exactTel as GQL.ITelephone).databaseId,
          },
        })
      );
    }
  };

  const handleEmailValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInptEmail(e.target.value);
  };

  const handleTelephoneValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInptTelephone(e.target.value);
  };

  const handleEmailExit = useCallback(() => {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    setEmailError(!re.test(inptEmail));
  }, [inptEmail]);

  const handleTelExit = useCallback(() => {
    if (inptTelephone.length < 15) {
      setTelError(true);
    } else {
      setTelError(false);
    }
  }, [inptTelephone]);

  const handleSignUp = async () => {
    if (!emailError && inptEmail) {
      setLoading(true);
      const confirmeData = await api.getUserConfirmedData();
      dispatch(
        setUserConfirmedData.request({
          data: { ...confirmeData, email: inptEmail },
        })
      );
    }

    if (!telError && inptTelephone) {
      setLoading(true);
      const telReverse = formatTelephoneReverse(inptTelephone);
      const ddd = telReverse.slice(0, 2);
      const telephone = telReverse.slice(2);
      const confirmeData = await api.getUserConfirmedData();
      dispatch(
        setUserConfirmedData.request({
          data: { ...confirmeData, telephone, ddd_tel: ddd },
        })
      );
    }
  };

  if (contactsLoading) return null;

  return (
    <Modal
      title={
        code === 'Email'
          ? userContacts.length
            ? 'Confirme seu E-mail:'
            : 'Cadastrar E-mail:'
          : code === 'SMS' || code === 'Whatsapp'
          ? userContacts.length
            ? 'Confirme seu Telefone:'
            : 'Cadastrar Telefone:'
          : code === 'Endereco'
          ? 'Cadastrar novo Endereço:'
          : 'Não há nada aqui'
      }
      handlerClose={handlerClose}
      width={
        window.matchMedia('(max-width: 960px)').matches ? '360px' : '464px'
      }
      confirmData
    >
      <Content>
        {code === 'Email' && (
          <>
            <ContactsListContainer userContactsLength={userContacts.length}>
              {userContacts && userContacts.length ? (
                <>
                  {userContacts.map((contact, index) => (
                    <ConfirmationCard
                      key={index}
                      contentCardText={(contact as GQL.IEmail).email}
                      id={index + 1}
                      selectedId={emailCode}
                      setOption={setEmailCode}
                      setNew={setNewContact}
                      error={emailError}
                      setError={setEmailError}
                      resize
                    />
                  ))}
                  <ConfirmationCard
                    id={1000}
                    selectedId={emailCode}
                    setOption={setEmailCode}
                    haveChildren
                    error={emailError}
                    errorMessage={'E-mail inválido!'}
                    newContact={newContact}
                    setNew={setNewContact}
                    resize
                  >
                    <InputComponent
                      value={inptEmail}
                      handlerOnchange={handleEmailValue}
                      error={false}
                      placeholder={'Cadastrar novo E-mail'}
                      errorMessage={''}
                      height={'35px'}
                      onBlur={handleEmailExit}
                      newData
                      isChildren
                      newContact={newContact}
                    />
                  </ConfirmationCard>
                </>
              ) : (
                <>
                  <InputComponent
                    value={inptEmail}
                    handlerOnchange={handleEmailValue}
                    error={emailError}
                    errorMessage={'E-mail inválido'}
                    placeholder={'Digite um E-mail'}
                    height={'40px'}
                    onBlur={handleEmailExit}
                    newData
                  />
                  <Button
                    color='primary'
                    onClick={handleSignUp}
                    style={{ marginTop: '20px' }}
                    loading={loading}
                    disabled={loading}
                  >
                    Cadastrar
                  </Button>
                </>
              )}
            </ContactsListContainer>
            {userContacts && userContacts.length ? (
              <Button
                color='primary'
                onClick={newContact ? handleSignUp : handleConfirm}
                disabled={loading}
                style={{ marginTop: '20px' }}
              >
                Confirmar
              </Button>
            ) : null}
          </>
        )}
        {(code === 'SMS' || code === 'Whatsapp') && (
          <>
            <ContactsListContainer userContactsLength={userContacts.length}>
              {userContacts && userContacts.length ? (
                <>
                  {userContacts.map((contact, index) => (
                    <ConfirmationCard
                      key={index}
                      contentCardText={(contact as GQL.ITelephone).telephone}
                      id={index + 1}
                      selectedId={telCode}
                      setOption={setTelCode}
                      setNew={setNewContact}
                      error={telError}
                      setError={setTelError}
                      resize
                    />
                  ))}
                  <ConfirmationCard
                    id={1000}
                    selectedId={telCode}
                    setOption={setTelCode}
                    haveChildren
                    error={telError}
                    errorMessage={'Telefone inválido!'}
                    newContact={newContact}
                    setNew={setNewContact}
                    resize
                  >
                    <InputComponent
                      value={formatTelephone(inptTelephone)}
                      handlerOnchange={handleTelephoneValue}
                      error={false}
                      placeholder={'Cadastrar novo Telefone'}
                      errorMessage={''}
                      height={'35px'}
                      onBlur={handleTelExit}
                      newData
                      isChildren
                      newContact={newContact}
                      maxLength={15}
                    />
                  </ConfirmationCard>
                </>
              ) : (
                <>
                  <InputComponent
                    value={formatTelephone(inptTelephone)}
                    handlerOnchange={handleTelephoneValue}
                    error={telError}
                    errorMessage={'Telefone inválido'}
                    placeholder={'Digite um Telefone'}
                    height={'40px'}
                    onBlur={handleTelExit}
                    maxLength={15}
                    newData
                  />
                  <Button
                    color='primary'
                    onClick={handleSignUp}
                    style={{ marginTop: '20px' }}
                    loading={loading}
                    disabled={loading}
                  >
                    Cadastrar
                  </Button>
                </>
              )}
            </ContactsListContainer>
            {userContacts && userContacts.length ? (
              <Button
                color='primary'
                onClick={newContact ? handleSignUp : handleConfirm}
                disabled={loading}
                style={{ marginTop: '20px' }}
              >
                Confirmar
              </Button>
            ) : null}
          </>
        )}
        {code === 'Endereco' && (
          <>
            <div style={{ marginBottom: '18px' }}>
              <InputComponent
                value={cep}
                handlerOnchange={(e) => setCep(e.target.value)}
                error={false}
                errorMessage={''}
                placeholder={'CEP'}
                height={'40px'}
                newData
              />
            </div>
            <div style={{ marginBottom: '18px' }}>
              <InputComponent
                value={number}
                handlerOnchange={(e) => setNumber(e.target.value)}
                error={false}
                errorMessage={''}
                placeholder={'Número'}
                height={'40px'}
                newData
              />
            </div>
            <div style={{ marginBottom: '18px' }}>
              <InputComponent
                value={complement}
                handlerOnchange={(e) => setComplement(e.target.value)}
                error={false}
                errorMessage={''}
                placeholder={'Complemento (opcional)'}
                height={'40px'}
                newData
              />
            </div>
            <div style={{ marginBottom: '18px' }}>
              <InputComponent
                value={neighborhood}
                handlerOnchange={(e) => setNeighborhood(e.target.value)}
                error={false}
                errorMessage={''}
                placeholder={'Bairro'}
                height={'40px'}
                newData
              />
            </div>
            <div style={{ marginBottom: '18px' }}>
              <InputComponent
                value={city}
                handlerOnchange={(e) => setCity(e.target.value)}
                error={false}
                errorMessage={''}
                placeholder={'Cidade'}
                height={'40px'}
                newData
              />
            </div>
            <div style={{ marginBottom: '18px' }}>
              <InputComponent
                value={state}
                handlerOnchange={(e) => setState(e.target.value)}
                error={false}
                errorMessage={''}
                placeholder={'UF'}
                height={'40px'}
                newData
                maxLength={2}
              />
            </div>
            <Button
              color='primary'
              onClick={handleAddressSubmit}
              style={{ marginTop: '12px' }}
              loading={loading}
              disabled={loading}
            >
              Cadastrar Endereço
            </Button>
          </>
        )}
      </Content>
    </Modal>
  );
};

export default ConfirmData;
